/**
* @author ayou[beica1@outook.com]
* @date 2022/3/8 16:20
* @description
*   TheTrend.vue of WeTrade
*/
<template>
<div class="trade-trend df-middle c-title">
  <t path="symbol_2" class="f-sm">Market Sentiment</t>
  <div class="bar flex-1 ml-10">
    <div class="positive" :style="{width: `${trend.up}%`}"></div>
  </div>
</div>
</template>

<script lang="ts">
import { readTradeTrend } from '@/modules/market/market.api'
import { defineComponent, shallowRef, watchEffect } from 'vue'

export default defineComponent({
  name: 'TheTrend',
  props: {
    code: {
      type: String,
      required: true,
    },
  },
  setup (props) {
    const trend = shallowRef({ up: 50 })

    watchEffect(() => {
      if (props.code) {
        readTradeTrend({
          contract: props.code,
        }).then(resp => trend.value = resp)
      }
    })

    return {
      trend,
    }
  },
})
</script>

<style scoped lang="scss">
.trade-trend {
  position: absolute;
  left: 20px;
  top: 10px;
  width: 280px;
}

.bar {
  height: 4px;
  overflow: hidden;
  background: var(--color-danger);
}

.positive {
  position: relative;
  height: 100%;
  background: var(--color-success);

  &::after {
    position: absolute;
    top: -50%;
    height: 200%;
    right: -1px;
    width: 2px;
    background: white;
    display: inline-block;
    transform: rotate(45deg);
    content: "";
  }
}
</style>
